import { render } from "./PageViewPSBditerima.vue?vue&type=template&id=36a473bf"
import script from "./PageViewPSBditerima.vue?vue&type=script&lang=js"
export * from "./PageViewPSBditerima.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__